import { ApolloCache, DefaultContext, MutationFunctionOptions, OperationVariables } from '@apollo/client'
import { areYouSurePrompt } from '../../../utils/helper'
import { question } from './SMSTpv.types'
import './smsTPV.css'
import { generateSaveAnswerPayload } from './SMSTpvUtils'
const Question = ({
  questionData,
  setQuestions,
  questionDisabled,
  questions,
  saveAnswer,
  pincode
}: {
  questionData: question
  setQuestions: React.Dispatch<React.SetStateAction<question[]>>
  questionDisabled: boolean
  questions: question[]
  saveAnswer: (options?: MutationFunctionOptions<any, OperationVariables, DefaultContext, ApolloCache<any>> | undefined) => Promise<any>
  pincode: string | null
}) => {
  const { question, questionType, id, position, isNo, isYes, dtmfAnswer, error, continueCall, answered } = questionData
  return (
    <div className={`d-flex flex-column my-5 w-100 ${questionDisabled && 'question-disabled'}`}>
      <div className={`${error ? "alert-danger" : "bg-f4f4f4"} p-5 mb-7 rounded-3`}>
        <div className='d-flex flex-column align-items-center gap-4 '>
          <div>
            <h5 className='fs-3 me-4 text-gray-600 d-inline'>Question</h5>
            <div
              className='bg-gray-700  p-2 w-30px h-30px text-center text-white d-inline-block'
              style={{ borderRadius: '6px' }}
            >
              {position + 1}
            </div>
          </div>
          <div className='text-center'>
            <h6 className='w-100 fs-3'>{question}</h6>

            {(questionType === 'YESNO' || questionType === 'BOTH_OPTION') && (
              <div className='form-check  justify-content-center form-check-custom form-check-solid mt-7'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  checked={isYes}
                  id='YESNO'
                  disabled={questionDisabled}
                  onChange={() => {
                    setQuestions((prev) =>
                      prev.map((question) => {
                        if (question.id === id) {
                          if (questionType === 'BOTH_OPTION') {
                            return {
                              ...question,
                              isYes: !question.isYes,
                              isNo: false,
                              answered: true,
                              dtmfAnswer: '',
                              error: false
                            }
                          } else {
                            return {
                              ...question,
                              isYes: !question.isYes,
                              isNo: false,
                              answered: true,
                              error: false
                            }
                          }
                        }

                        return question
                      })
                    )
                  }}
                />
                <label className='form-check-label' htmlFor='YES'>
                  Yes
                </label>
                <input
                  className='form-check-input ms-5'
                  type='checkbox'
                  checked={isNo}
                  id='DTMF'
                  disabled={questionDisabled}
                  onChange={() => {
                    if (continueCall === false) {
                      areYouSurePrompt(
                        'Are you sure',
                        () => {
                          let answerPayload: question[] = []
                          let currentIndex = questions.indexOf(questions.filter((question: question) => question.id === id)[0])
                          answerPayload = questions.map((question, index) => {
                            if (question.id === id) {
                              currentIndex = index
                              if (questionType === 'BOTH_OPTION') {
                                return {
                                  ...question,
                                  isNo: !question.isNo,
                                  isYes: false,
                                  answered: true,
                                  dtmfAnswer: '',
                                }
                              } else {
                                return {
                                  ...question,
                                  isNo: !question.isNo,
                                  isYes: false,
                                  answered: true,
                                }
                              }
                            }
                            return question
                          })
                          if (currentIndex === 0) {
                            answerPayload = [answerPayload[0]]
                          }
                          else {
                            answerPayload = answerPayload.slice(0, currentIndex + 1)
                          }
                          saveAnswer({
                            variables: {
                              pincode: pincode,
                              answerInput: generateSaveAnswerPayload(answerPayload)
                            },
                          })
                        },
                        () => { },
                        "Yes",
                        "No",
                        "",
                        "<p>Answering <span class='text-danger'>No</span> to this question will <span class='text-danger'>fail</span> the TPV. Are you sure to proceed? </p>",
                      )
                    } else {
                      setQuestions((prev) =>
                        prev.map((question) => {
                          if (question.id === id) {
                            if (question.id === id) {
                              if (questionType === 'BOTH_OPTION') {
                                return {
                                  ...question,
                                  isNo: !question.isNo,
                                  isYes: false,
                                  answered: true,
                                  dtmfAnswer: '',
                                  error: false
                                }
                              } else {
                                return {
                                  ...question,
                                  isNo: !question.isNo,
                                  isYes: false,
                                  answered: true,
                                  error: false
                                }
                              }
                            }
                          }
                          return question
                        })
                      )
                    }
                  }}
                />
                <label className='form-check-label' htmlFor='DTMF'>
                  No
                </label>
              </div>
            )}
            {(questionType === 'DTMF' || questionType === 'BOTH_OPTION') && (
              <div>
                <label className={`d-flex align-items-center mb-2 mt-3`}>
                  <div className='fs-6 fw-semibold lh-23px'>Other</div>
                </label>
                <input
                  id='other'
                  type='text'
                  className='form-control form-control-lg form-control-solid bg-white'
                  name='other'
                  value={dtmfAnswer}
                  placeholder='Enter Answer'
                  disabled={questionDisabled}
                  onChange={(e) => {
                    setQuestions((prev) =>
                      prev.map((question) => {
                        if (question.id === id) {
                          if (questionType === 'BOTH_OPTION') {
                            return {
                              ...question,
                              dtmfAnswer: e.target.value,
                              answered: true,
                              isYes: false,
                              isNo: false,
                              error: false
                            }
                          } else {
                            return {
                              ...question,
                              dtmfAnswer: e.target.value,
                              answered: true,
                              error: false
                            }
                          }
                        }
                        return question
                      })
                    )
                  }}
                />
              </div>
            )}
            {questionType === 'VOICE_RESPONSE' && (
              <div>
                <label className={`d-flex align-items-center mb-2 mt-3`}>
                  <div className='fs-6 fw-semibold lh-23px'>Please type your anwser</div>
                </label>
                <input
                  id='other'
                  type='text'
                  className='form-control form-control-lg form-control-solid bg-white'
                  name='voiceResponse'
                  value={dtmfAnswer}
                  placeholder='Enter Answer'
                  disabled={questionDisabled}
                  onChange={(e) => {
                    setQuestions((prev) =>
                      prev.map((question) => {
                        if (question.id === id) {
                          return {
                            ...question,
                            dtmfAnswer: e.target.value,
                            answered: true,
                            error: false
                          }
                        }
                        return question
                      })
                    )
                  }}
                />
              </div>
            )}
            {questionType === 'SPEECH_ONLY' && (
              <button
                className={`btn btn-${questionData.answered ? "primary" : "secondary"} mw-150px align-self-center`}
                disabled={questionDisabled}
                onClick={() => {
                  setQuestions((prev) =>
                    prev.map((question) => {
                      if (question.id === id) {
                        return {
                          ...question,
                          answered: true,
                        }
                      }
                      return question
                    })
                  )
                }}
              >
                Continue
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default Question
